const defaultOptions = {
  render: 'explicit'
}

export const loadRecaptcha = (opts = {}) => {
  const options = Object.assign({}, defaultOptions, opts)

  return new Promise((resolve, reject) => {
    if (window.hfbRecaptchaCallback) {
      resolve()
      return
    }

    window.hfbRecaptchaCallback = resolve
    const tag = document.createElement('script')
    tag.src = `https://www.google.com/recaptcha/api.js?onload=hfbRecaptchaCallback&render=${options.render}`
    const body = document.getElementsByTagName('body')[0]
    body.appendChild(tag)
  })
}
